import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
const PageNotFound = () => {
    const navigate = useNavigate();
    return (
        <>
            <main>
                <div className="form_outer_bg">
                    <div className="form_box_cover login_cover">
                        <div className="text_box">
                            <div className="login_box" style={{ display: 'flex', justifyContent: 'center' }}>
                                <lottie-player
                                    src="https://lottie.host/dca910b1-0bf2-4be3-821d-bdebd0b22439/WfCrrjv5Sx.json"
                                    background="transparent"
                                    speed="1"
                                    style={{ width: '200px', height: '200px' }}
                                    loop
                                    autoplay
                                    direction="1"
                                    mode="normal"
                                ></lottie-player>
                            </div>
                            <h2>Page Not Found</h2>
                            <p>The page you are looking for is not found</p>
                        </div>
                        <p className="extra_bottom_text">
                            <Button
                                variant="secondary"
                                className="btn dark_btn custom_btn"
                                onClick={() => navigate('/')}
                            >
                                Go Back
                            </Button>
                        </p>
                    </div>
                </div>
            </main>
            <footer>
                <div className="reg_footer_cover">
                    <p>Rcm E-bidding 2023</p>
                </div>
            </footer>
        </>
    );
};
export default PageNotFound;
